export function phoneDigits(value: string): string {
	const digits = value.replace(/\D/g, "");
	const national = digits.startsWith("1") ? digits.slice(1) : digits;
	return national.slice(0, 10);
}

export function formatPhoneNumber(value: string): string {
	const digits = phoneDigits(value);
	if (digits.length < 4) {
		return digits;
	}
	if (digits.length < 7) {
		return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
	}
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
